import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_rest_breaks_rotations_workers_who_are_exposed'

export const dataPointDefinition = {
  retracedId: 'no_rest_breaks_rotations_workers_who_are_exposed',
  name: 'No rest breaks and/or rotations for workers who are exposed to heat/radiation',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-wor-62x',
      number: 'HS-WOR-29-3',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-59',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-wor-17,Yes',
      machineShowHide: '[2],hs-wor-17,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-62x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32020,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
